import React from "react";
import { Icon } from "antd";
import Dropzone from "react-dropzone";

import UserContext from "../../Contexts/UserContext";
import MessengerContent from "./MessengerContent";
import MessengerFooter from "./MessengerFooter";

import NotificationBubble from "./NotificationBubble";

class Messenger extends React.Component {
  state = {
    visible: true,
    accept: "",
    files: [],
    dropzoneActive: false,
    dropzoneRef: null,
    isNewMessage: false,
    bubbleVisible: false,
    isSubscribed: false
  };

  onDragEnter() {
    this.setState({
      dropzoneActive: true
    });
  }

  onDragLeave() {
    this.setState({
      dropzoneActive: false
    });
  }

  onDrop(selectedfiles) {
    this.setState(({ files }) => ({
      files: [...files, ...selectedfiles],
      dropzoneActive: false
    }));
  }

  onRemove = file => {
    this.setState(({ files }) => {
      const index = files.indexOf(file);
      const newFileList = files.slice();
      newFileList.splice(index, 1);
      return {
        files: newFileList
      };
    });
  };

  applyMimeTypes(event) {
    this.setState({
      accept: event.target.value
    });
  }

  handleVisibility = () => {
    this.setState({ visible: !this.state.visible });
  };

  // Clear selected files state
  handleClearFiles = () => {
    this.setState({ files: [] });
  };

  render() {
    const {
      accept,
      dropzoneActive,
      visible,
      dropzoneRef,
      files,
      bubbleVisible,
      isSubscribed
    } = this.state;
    const overlayStyle = {
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      padding: "2.5em 0",
      background: "rgba(0,0,0,0.2)",
      textAlign: "center",
      color: "#fff",
      zIndex: 10
    };
    const { orderId } = this.props;

    return (
      <UserContext.Consumer>
        {({ profile }) => (
          <React.Fragment>
            <NotificationBubble
              messengerVisible={visible}
              bubbleVisible={bubbleVisible}
              active={isSubscribed => this.setState({ isSubscribed })}
            />
            <div
              className="messenger-wrapper hidden"
              style={visible ? { display: "none" } : {}}
            >
              <div className="messenger-header">
                <span>Seguimiento de la orden</span>
                <div>
                  <i
                    className="fas fa-bell"
                    style={{
                      fontSize: "1.5rem",
                      color: isSubscribed ? "var(--color-green-com)" : "white",
                      paddingRight: "1rem"
                    }}
                    onClick={() =>
                      this.setState({ bubbleVisible: !bubbleVisible })
                    }
                  />
                  <Icon type="arrows-alt" onClick={this.handleVisibility} />
                </div>
              </div>
            </div>
            <div
              className="messenger-wrapper"
              style={!visible ? { display: "none" } : {}}
            >
              <Dropzone
                ref={dz =>
                  !this.state.dropzoneRef && this.setState({ dropzoneRef: dz })
                }
                disableClick
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: "1"
                }}
                accept={accept}
                onDrop={this.onDrop.bind(this)}
                onDragEnter={this.onDragEnter.bind(this)}
                onDragLeave={this.onDragLeave.bind(this)}
              >
                {dropzoneActive && (
                  <div style={overlayStyle}>Suelta archivos...</div>
                )}
                {/* Header */}
                <div className="messenger-header">
                  <span>Seguimiento de la orden</span>
                  <div>
                    <i
                      className="fas fa-bell"
                      style={{
                        fontSize: "1.5rem",
                        color: isSubscribed
                          ? "var(--color-green-com)"
                          : "white",
                        paddingRight: "1rem"
                      }}
                      onClick={() =>
                        this.setState({ bubbleVisible: !bubbleVisible })
                      }
                    />
                    <Icon type="arrows-alt" onClick={this.handleVisibility} />
                  </div>
                </div>
                {/* Content */}
                <div className="messenger-list">
                  <MessengerContent
                    orderId={orderId}
                    isNewMessage={this.state.isNewMessage}
                    setIsNewMessage={() =>
                      this.setState({ isNewMessage: false })
                    }
                  />
                </div>

                {/* Footer */}
                <div className="messenger-footer">
                  <MessengerFooter
                    dropzoneRef={dropzoneRef}
                    orderId={orderId}
                    files={files}
                    onRemove={this.onRemove}
                    user={profile}
                    handleClearFiles={this.handleClearFiles}
                    setIsNewMessage={() =>
                      this.setState({ isNewMessage: true })
                    }
                  />
                </div>
              </Dropzone>
            </div>
          </React.Fragment>
        )}
      </UserContext.Consumer>
    );
  }
}

export default Messenger;



// WEBPACK FOOTER //
// ./src/Components/Comments/Messenger.js